import React from 'react';
import { EyeIcon, CalendarCheckIcon, DumbbellIcon, FootprintsIcon, ActivityIcon, LayoutGridIcon, TrendingUpIcon, CalendarRangeIcon } from 'lucide-react';
const capabilities = [{
  icon: EyeIcon,
  label: 'Visual Exercise Selection'
}, {
  icon: CalendarCheckIcon,
  label: 'Ready-to-Teach Classes'
}, {
  icon: DumbbellIcon,
  label: 'Strength & Functional Training'
}, {
  icon: FootprintsIcon,
  label: 'Balance & Coordination Activities'
}, {
  icon: ActivityIcon,
  label: 'Mobility & Active Aging'
}, {
  icon: LayoutGridIcon,
  label: 'Circuits & Training Stations'
}, {
  icon: TrendingUpIcon,
  label: 'Ability-Level Progressions'
}, {
  icon: CalendarRangeIcon,
  label: 'Long-Term Programming'
}];
export function IncludedGrid() {
  return <section className="bg-ivory px-4 sm:px-6 py-9 sm:py-12" data-id="element-105" data-mp="3pk7vycqyhlda">
      <div className="max-w-4xl mx-auto" data-id="element-106" data-mp="qx3pcocj1fpg">
        <h2 className="font-heading font-extrabold uppercase text-base sm:text-2xl leading-tight tracking-tight text-petrol text-center mb-6 max-w-2xl mx-auto" data-id="element-107" data-mp="qy52qzh0meac">
          Everything your senior fitness program needs —{' '}
          <span className="text-green-dark" data-id="element-108" data-mp="1o2ausnylpe4f">in one place</span>
        </h2>

        <ul className="grid grid-cols-2 lg:grid-cols-4 gap-2 mb-6" data-id="element-109" data-mp="1o4eyb4sl8b46">
          {capabilities.map(({
          icon: Icon,
          label
        }) => <li key={label} className="bg-white border border-petrol/10 rounded-lg px-3 py-3.5 flex flex-col items-center text-center gap-1.5" data-id="element-110" data-mp="1ec96pw68zvpi">
              <Icon className="w-4 h-4 sm:w-5 sm:h-5 text-green shrink-0" data-id="element-111" data-mp="15bt8b14d3eri" />
              <span className="font-heading font-bold uppercase text-[9px] sm:text-[11px] tracking-wide text-petrol leading-snug" data-id="element-112" data-mp="15a01nltr0uji">
                {label}
              </span>
            </li>)}
        </ul>

        <div className="max-w-md mx-auto bg-white border border-petrol/10 rounded-lg p-4 text-center" data-id="element-113" data-mp="2lqclvgltr6mz">
          <p className="text-[11px] sm:text-xs font-semibold text-petrol/55 mb-2" data-id="element-114" data-mp="2pro594e3uvmq">
            One system designed to take you from:
          </p>
          <p className="font-heading font-bold text-[13px] sm:text-base text-petrol/50 line-through decoration-petrol/25 mb-2" data-id="element-115" data-mp="2l1tt2mu66tj">
            "What should I teach?"
          </p>
          <p className="text-[11px] sm:text-xs font-semibold text-petrol/55 mb-1.5" data-id="element-116" data-mp="3pnergbvhnam0">
            to:
          </p>
          <p className="font-heading font-extrabold uppercase text-[13px] sm:text-base tracking-tight text-green-dark" data-id="element-117" data-mp="3kqessm0yxa4x">
            "I already have something ready."
          </p>
        </div>
      </div>
    </section>;
}